import { DEFAULT_VIEW_TYPE } from '@anm/constants/videoLandings';
import isInIframe from '@anm/helpers/is/isInIframe';
import { useCallback, useEffect, useState } from 'react';

var useChangeViewType = function useChangeViewType() {
  var isCustomization = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = useState(DEFAULT_VIEW_TYPE),
      viewType = _useState[0],
      setViewType = _useState[1];

  var onReceiveMessage = useCallback(function (_ref) {
    var data = _ref.data;
    data.viewType && setViewType(data.viewType);
  }, []);
  useEffect(function () {
    if (!isInIframe() || !isCustomization) return;
    window.addEventListener('message', onReceiveMessage);
    return function () {
      return window.removeEventListener('message', onReceiveMessage);
    };
  }, [isCustomization]);
  return viewType;
};

export default useChangeViewType;